"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterText = void 0;
const components_1 = require("@apitable/components");
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const FilterText = props => {
    const { value, onChange } = props;
    const _value = value === null || value === void 0 ? void 0 : value[0];
    return (react_1.default.createElement(styled_1.FilterInputWrap, null,
        react_1.default.createElement(components_1.TextInput, { className: 'widgetFilterTextInput', block: true, value: _value, onChange: (e) => {
                const value = e.target.value;
                onChange(value ? [value] : null);
            }, placeholder: '' })));
};
exports.FilterText = FilterText;
